import React from 'react';

import { withStyles, ButtonBase, Grid, Typography } from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"
import Live from '../../model/Live';

const ICON1 = require("../../images/icons/ren_icon.png");
const ICON2 = require("../../images/icons/recomm.png");
const ICON3 = require("../../images/icons/huo_icon.png");

class PreviewDoubleItem extends React.Component {

    _onClickAnchor = (data) => {
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.match_type ? data.match_type : 0;
        let match_id = data.match_id ? data.match_id : 0;
        this.props.history.push({ pathname: '/play/' + room_id + '/' + match_type + '/' + match_id, data: data });
    }

    render() {
        let { classes, data, isRocomm, hot } = this.props;
        let live = new Live(data);
        var tips = '休息';
        if (live.living()) {
            tips = '直播中';
        }

        let room_cover = data.room_cover;
        if (data.screen_shots && data.screen_shots.length > 0) {
            room_cover = data.screen_shots;
        }

        return (
            <Grid item container className={classes.root} style={this.props.style} justify='flex-start'>
                <ButtonBase disableRipple className={classes.buttonBase}
                    style={{
                        backgroundSize: 'cover',
                        backgroundImage: `url(${room_cover})`,
                        backgroundRepeat: 'no-repeat',
                    }}
                    onClick={() => this._onClickAnchor(data)} >
                    {
                        tips ? <Grid container direction='row' alignItems='center' className={classes.mosaicBg}>
                            <div className={live.living() ? classes.point : classes.point1}></div>
                            <Typography style={{ color: '#FFF', fontSize: 9, marginLeft: 4 }}>{tips}</Typography>
                        </Grid>
                            : null
                    }
                    {
                        isRocomm ? <Grid container direction='row' alignItems='center' className={classes.recommBg}>
                            <img src={ICON2} style={{ width: 40, height: 19 }}></img>
                        </Grid>
                            : null
                    }
                    <Grid container direction='row' justify='space-between' alignItems='center' className={classes.scoreBg}>
                        <Typography style={{ color: '#FFF', marginLeft: 8, fontSize: 9 }} >{data.nickName}</Typography>
                        <Grid container direction='row' alignItems='center' justify='flex-end' style={{ flex: 1 }} >
                            <img src={ICON1} style={{ width: 10, height: 10, marginRight: 4 }}></img>
                            <Typography style={{ color: '#FFF', marginRight: 8, fontSize: 9 }}>{data.heat}</Typography>
                        </Grid>
                    </Grid>
                </ButtonBase>
                <Grid container direction='row' alignItems='center'>
                    {
                        hot && <img src={ICON3} style={{ width: 15, height: 15 }}></img>
                    }
                    <Typography align='left' noWrap style={{ flex: 1, color: '#0D0D0D', fontSize: 13, marginTop: 4, marginRight: 8 }} >{data.room_title}</Typography>
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        marginTop: 0,
        padding: theme.spacing(0, 0, 1, 0),
    },
    buttonBase: {
        width: '100%',
        height: '26vw',
        borderRadius: 6,
    },
    scoreBg: {
        display: 'flex',
        justifyContent: '',
        alignItems: 'center',
        padding: theme.spacing(0),
        position: 'absolute',
        bottom: 0,
        width: '100%',
        height: 26.5,
        background: 'linear-gradient(0deg, #00000099 0%, #00000000 100%)',
        borderBottomLeftRadius: 6,
        borderBottomRightRadius: 6,
    },
    mosaicBg: {
        position: 'absolute',
        top: 8,
        left: 8,
        padding: theme.spacing(0.2, 0.6),
        backgroundColor: '#0000005F',
        borderRadius: 10,
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
        maxWidth: 54,
    },
    recommBg: {
        position: 'absolute',
        top: 0,
        right: 0,
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
        maxWidth: 48,
    },
    point: {
        width: 4,
        height: 4,
        backgroundColor: '#8CF63E',
        borderRadius: 2,
    },
    point1: {
        width: 4,
        height: 4,
        backgroundColor: '#F7F7F7',
        borderRadius: 2,
    }
}))(PreviewDoubleItem));